import React, { useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBoxCenter } from '@ecp/common/src/layouts/flex/styled';
import FileUploaderUnstyled from '@ecp/common/src/components/unstyled/input/FileUploaderUnstyled';
import { ReactComponent as AddIcon } from '@ecp/common/src/assets/icon/icon__add.svg';

const UploaderDropzone = React.forwardRef(({ guideMessage, onChange, ...props }, ref) => {
  const fileUploaderRef = useRef(null);
  useImperativeHandle(ref, () => fileUploaderRef.current);

  return (
    <>
      <FileUploaderUnstyled
        dragdrop
        rootComponent={StyledFileUploaderRoot}
        dropzoneComponent={DefaultDropzoneComponent}
        buttonComponent={
          <DefaultButtonComponent>
            <>
              <AddIcon />
              PC파일추가
            </>
          </DefaultButtonComponent>
        }
        multiple
        onChange={onChange}
        ref={fileUploaderRef}
        guideComponent={<GuideMessage>{guideMessage}</GuideMessage>}
        {...props}
      ></FileUploaderUnstyled>
    </>
  );
});

export const StyledFileUploaderRoot = styled.div`
  width: 100%;
  position: relative;
`;

const DefaultDropzoneComponent = styled(FlexBoxCenter)`
  width: 100%;
  height: 72px;
  border: 1px solid ${boTheme.color.sub7};
  background-color: ${({ active }) => (active === 'active' ? 'pink' : `${boTheme.color.sub8}`)};

  & > label {
    position: absolute;
    top: 10px;
    transform: translateX(-50%);
    left: 50%;
  }
`;

const DefaultButtonComponent = styled(FlexBoxCenter)`
  justify-self: stretch;
  padding: 4px 0;
  pointer-events: none;
  gap: 8px;

  font-size: ${boTheme.font.size.small};
  font-weight: ${boTheme.font.weight.bold};
  color: #000000;
`;

const GuideMessage = styled.div`
  position: absolute;
  bottom: 10px;

  font-size: 12px;
  font-weight: 400;
  color: ${boTheme.color.sub2};
`;

UploaderDropzone.propTypes = {
  guideMessage: PropTypes.string,
  onChange: PropTypes.func,
};

UploaderDropzone.displayName = 'UploaderDropzone';

export default UploaderDropzone;
